import * as React from "react";
import { map, size } from "lodash";
import styled from "styled-components";
import { Locale } from "@linkfluence/models/locale";
import QueryPortrait from "@radarly/components/portrait/query";
import { tr } from "@radarly/i18n";
import { Project } from "@radarly/models/project";
import { Query } from "@radarly/models/queries";
import Block, { Type } from "./block";

const Parent = styled.span`
  margin-left: 4px;
  font-weight: bold;
  font-size: 12px;
`;

const Separator = styled.span`
  margin: 0 12px;
`;

interface IProps {
  title: string;
  locale: Locale;
  parents?: Query[];
  project: Project;
  type: Type;
}

const QueriesInfoParentModal = ({
  title,
  locale,
  parents = [],
  type,
  project,
}: IProps) => {
  return (
    <Block title={title} icon="folder-magnifier" type={type}>
      {map(parents, (parent, i) => (
        <span key={parent.id}>
          <QueryPortrait
            size="s"
            picture={parent.imageUrl}
            borderColor={parent.color}
          />
          <Parent>{parent.label}</Parent>
          {i < size(parents) - 1 && <Separator> OR </Separator>}
        </span>
      ))}
      {!size(parents) && (
        <span>{tr(locale, "QUERY_DETAILS.INCLUDE_PARENTS_ALL")}</span>
      )}
    </Block>
  );
};

export default QueriesInfoParentModal;
